import { createContext } from 'react';
import { UAState, CallState } from '../types';

export const VoIPContext = createContext({
  // Connection state
  uaState: UAState.DISCONNECTED,
  isRegistered: false,
  hasJsSipExtension: false,

  // Call state
  callState: CallState.IDLE,
  currentCall: null,

  // Actions
  makeCall: () => {},
  answerCall: () => {},
  hangUp: () => {},
  toggleMute: () => {},
  toggleHold: () => {},

  // Dialer UI state
  isDialerOpen: false,
  isDialerMinimized: false,
  openDialer: () => {},
  closeDialer: () => {},
  minimizeDialer: () => {},
  maximizeDialer: () => {},

  // Audio state
  isMuted: false,
  isOnHold: false,
  
  // Debug panel
  showDebugPanel: false,
  toggleDebugPanel: () => {},

  // Recording
  isRecording: false,
  isUploading: false,
});
